/**
 *  试题模块
 */
import http from '../assets/js/http'
// 多个试题分类名称
export const getFlmcs = (params) => { return http.request({ url: '/questions/classify/getFlmcs', method: 'get', params: params }) }
// 试题分类列表
export const getClassifyList = (params) => { return http.request({ url: '/questions/classify/getList', method: 'get', params: params }) }
// 保存试题分类
export const saveClassify = (params) => { return http.request({ url: '/questions/classify/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 试题列表
export const getList = (params) => { return http.request({ url: '/questions/getList', method: 'get', params: params }) }
// 试题列表（带试题选项等）
export const getStList = (params) => { return http.request({ url: '/questions/getStList', method: 'get', params: params }) }
// 试题详情
export const detail = (params) => { return http.request({ url: '/questions/detail', method: 'get', params: params }) }
// 试题保存
export const save = (params) => { return http.request({ url: '/questions/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 试题批量保存
export const saveBatch = (params) => { return http.request({ url: '/questions/saveBatch', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 试题更新
export const edit = (params) => { return http.request({ url: '/questions/edit', method: 'post', params: params }) }
// 试题删除
export const remove = (params) => { return http.request({ url: '/questions/remove', method: 'post', params: params }) }
// 获取试题题型
export const getTypeOfQuestion = () => { return http.request({ url: '/questions/getTxList', method: 'get' }) }
// 统计试题个数
export const getStCount = (params) => { return http.request({ url: '/questions/getStCount', method: 'get', params: params }) }
// 抽取试题
export const getStkListRand = (params) => { return http.request({ url: '/questions/getStkListRand', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 删除试题类型
export const removeClassify = (params) => { return http.request({ url: '/questions/classify/remove', method: 'post', params: params }) }
// 批量修改试题题型
export const batchEditQuestion = (params) => { return http.request({ url: '/questions/batchEdit', method: 'post', params: params }) }
// 获取试题详情（编辑试题）
export const selectStListkById = (params) => { return http.request({ url: '/questions/getStListForUpdate', method: 'get', params: params }) }
// 检查是否存在数据
export const checkExistsData = (params) => { return http.request({ url: '/questions/classify/checkExistsData', method: 'get', params: params }) }
